// codigo que inicializa el slider de simple
// no tocar
var carouselOptions = {
  lazy: false,
  pagination: true,
  paginationNumbers: true,
  transitionStyle: "fade",
  autoPlay: true,
  singleItem: true,
  afterInit: LazyLoad.update,
};
$('.js-home-carousel').owlCarousel(carouselOptions);

// codigo de control del menu en mobile
const menuMobile = {
  $fixedContainer: $('.ribbon-menu-mobile-fixed'),
  open: function () {
    $('body').addClass('rp-menu-mobile-opened');
    $('.menu').addClass('active-mobile');
    menuMobile.$fixedContainer.removeClass('is-shown');
  },
  close: function () {
    $('body').removeClass('rp-menu-mobile-opened');
    $('.menu').addClass('is-closed');
    menuMobile.handleScroll();
    setTimeout(
      () => $('.menu').removeClass('active-mobile is-closed'),
      300
    );
  },
  openSubItems: function () {
    const $this = $(this);
    if ($this.hasClass('active')) {
      $this.removeClass('active');
    } else {
      $('.submenu').removeClass('active');
      $this.addClass('active');
    }
  },
  handleScroll: function () {
    const tresholdToShow =
      document.querySelector('#openMenu').getBoundingClientRect().top;

    if (tresholdToShow <= 0) {
      menuMobile.$fixedContainer.addClass('is-shown');
    } else {
      menuMobile.$fixedContainer.removeClass('is-shown');
    }
  }
};

document.addEventListener('scroll', menuMobile.handleScroll);
$('.open-menu-mobile').on('click', menuMobile.open);
$('.close-menu-mobile').on('click', menuMobile.close);
var $submenu = $('.submenu');
var submenuIsActive = $submenu.find('.active').length > 0;

$submenu.on('click', menuMobile.openSubItems);

if (submenuIsActive && window.matchMedia("(max-width: 767px)").matches) {
  $submenu.addClass('active');
}

// codigo de control de bloques colapsables
$('.rp-collapse').on('click', function () {
  var $this = $(this);
  var $container = $this.siblings('.rp-collapsable');
  // cerrar todos los colapsables menos el actual
  $('.rp-collapse, .rp-collapsable')
    .not(this)
    .not($container)
    .removeClass('open');
  $this.toggleClass('open');
  $container.toggleClass('open');
});

// codigo de control de tabs
$('.rp-tabs .tab-headers li').on('click', function () {
  var $this = $(this);
  var $pane = $($('.rp-tabs .tab-content section')[$this.index()]);
  $('.rp-tabs .tab-headers li, .rp-tabs .tab-content section').removeClass('active');
  $this.addClass('active');
  $pane.addClass('active');
});



// WEBPACK FOOTER //
// ./assets/js/index.js